import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'ng2-app/http/clients/api';
import { DebtScheduleItem } from 'ng2-app/models/dscr/DebtScheduleItem.struct';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DebtScheduleService {

  static debtTypeOptions = [
    {
      label: 'Credit Card',
      value: 'creditCard',
    },
    {
      label: 'Invoice Financing',
      value: 'invoiceFinancing',
    },
    {
      label: 'Term Loan',
      value: 'termLoan',
    },
    {
      label: 'Line of Credit',
      value: 'lineOfCredit',
    },
    {
      label: 'Shareholder Note',
      value: 'shareholderNote',
    },
  ];

  static paymentFrequencyOptions = [
    { label: 'Daily', value: 'daily' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Semi-monthly', value: 'semiMonthly' },
    { label: 'Monthly', value: 'monthly' },
  ];

  constructor(
    private http: ApiHttpClient,
  ) {}

  getDebtSchedules(borrowerId: number): Observable<DebtScheduleItem[]> {
    return this.http.get<DebtScheduleItem[]>(`${environment.API_URL}/borrower/${borrowerId}/debt-schedule-items`);
  }

  createDebtScheduleItem(borrowerId: number, debtScheduleItem: DebtScheduleItem): Observable<DebtScheduleItem[]> {
    return this.http.post<DebtScheduleItem[]>(`${environment.API_URL}/borrower/${borrowerId}/debt-schedule-items`, {debtScheduleItem});
  }

  updateDebtScheduleItem(borrowerId: number, debtScheduleItem: DebtScheduleItem): Observable<DebtScheduleItem> {
    return this.http.put<DebtScheduleItem>(
      `${environment.API_URL}/borrower/${borrowerId}/debt-schedule-items/${debtScheduleItem.id}`, {debtScheduleItem}
    );
  }

  deleteDebtScheduleItem(id: number): Observable<DebtScheduleItem> {
    return this.http.delete<DebtScheduleItem>(`${environment.API_URL}/debt-schedule-items/${id}`);
  }
}
